import { css } from "styled-components";
import { BorderSolidLightBlue } from "../BorderSolidLightBlue";
export const BlueFrameBoxTiny = css `
  ${BorderSolidLightBlue};
  border-radius: 1em;
`;
